import type { Package } from '@mypoz/shared';
import { daysInWarehouse } from '@mypoz/shared';

/**
 * Days a package has sat past its warehouse's free-storage window, or `undefined` if it hasn't
 * (or can't yet — no intake recorded, or the warehouse's free period isn't known).
 *
 * Single source of truth for "is this package at risk": `PackageListRow`'s warning line and
 * MYP-32's storage-risk filter both call this rather than each computing it their own way, so a
 * package the filter turns up always has a row that visibly agrees why.
 *
 * `freeDays` is passed in rather than looked up here. It comes from the warehouse record the
 * vendor sends (MYP-30), which arrives over the network and therefore is not available
 * synchronously to a module-level helper — and a lookup that silently answers "not at risk"
 * because the list had not loaded yet would be the quiet kind of wrong. Callers already hold the
 * warehouse; they hand over its `freeStorageDays`.
 */
export function overdueStorageDays(
  pkg: Package,
  now: Date,
  freeDays: number | undefined,
): number | undefined {
  const days = daysInWarehouse(pkg, now);
  return freeDays !== undefined && days !== undefined && days > freeDays ? days : undefined;
}
